import React, { useState } from "react";
import { toast } from "sonner";
import { PackageOpen } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button, Card } from "./ui-kit";
import MocaProductionDialog from "./MocaProductionDialog";

/**
 * «Vuoi associare un MOCA?» per una o più produzioni appena create (o per
 * quella dell'etichetta). «No» chiude solo la domanda: la sezione MOCA resta
 * sempre disponibile in Produzioni. «Non chiedere più» vale per la ricetta.
 */
export default function MocaPrompt({ productions, onDone, onAssociated }) {
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState("");
  const neverAsk = async (production) => {
    setBusy(production.id);
    try {
      await api.post(`/app/moca/productions/${production.id}/ask`, { ask_disabled: true });
      toast.success(`Per ${production.recipe_name} non verrà più chiesto il MOCA`);
      onDone(production.id);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  if (!productions.length) return null;
  return <Card className="border-sky-300 bg-sky-50 p-5" data-testid="moca-prompt">
    <div className="flex items-start gap-3">
      <PackageOpen className="mt-0.5 h-6 w-6 shrink-0 text-sky-700" />
      <div><h2 className="font-heading text-lg font-semibold text-sky-900">Vuoi associare un MOCA?</h2>
        <p className="text-sm text-sky-800">Indica l'imballaggio a contatto con il prodotto (vaschetta, film, sacchetto…) e il suo lotto. Serve soprattutto per le forniture B2B: tipologia e lotto compaiono sull'etichetta.</p></div>
    </div>
    <div className="mt-3 space-y-2">
      {productions.map((p) => <div key={p.id} className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-sky-200 bg-white p-3">
        <div><strong className="text-navy">{p.recipe_name}</strong> <span className="font-mono text-xs text-gold">{p.lot_code}</span></div>
        <div className="flex flex-wrap gap-2">
          <Button variant="success" onClick={() => setOpen(p.id)} data-testid={`moca-prompt-yes-${p.id}`}>Sì, associa</Button>
          <Button variant="outline" onClick={() => onDone(p.id)} data-testid={`moca-prompt-no-${p.id}`}>No</Button>
          <Button variant="ghost" loading={busy === p.id} onClick={() => neverAsk(p)} data-testid={`moca-prompt-never-${p.id}`}>No, non chiedere più per questa ricetta</Button>
        </div>
      </div>)}
    </div>
    {open && <MocaProductionDialog productionId={open} onClose={() => setOpen(null)} onSaved={(lots) => { const id = open; setOpen(null); onAssociated?.(id, lots); onDone(id); }} />}
  </Card>;
}
